// extracted by mini-css-extract-plugin
export default {"root":"LanguageBar_root__KP2Ow","tabs":"LanguageBar_tabs__A+Fwh"};